import comp from "./AssessmentOtherLearningGoalsModalBody";
export default comp;
